import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
let TagLabel = class TagLabel extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "point", void 0);
  }
};
__decorate([Prop({
  default: "dark"
})], TagLabel.prototype, "type", void 0);
__decorate([Prop({
  default: false
})], TagLabel.prototype, "point", void 0);
TagLabel = __decorate([Component({})], TagLabel);
export default TagLabel;